import CodeIcon from '@mui/icons-material/Code';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PieChartIcon from '@mui/icons-material/PieChart';
import { Grid, Typography } from '@mui/material';

import { Button } from '~/components/Button';
import Image from '~/components/Image';
import { useExtensionDetails } from '~/scripts/extension';

interface ResearchToolsButtonsProps {
  extension?: boolean;
  api?: boolean;
  mcp?: boolean;
  compare?: boolean;
}
export const ResearchToolsButtons = ({
  extension,
  api,
  mcp,
  compare,
}: ResearchToolsButtonsProps) => {
  const extensionDetails = useExtensionDetails();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Research Tools</Typography>
        <br />
        {extension && (
          <Button
            sx={{ mr: 2 }}
            href="/extension?utm_source=nerdydata-research-buttons"
            variant="outlined"
            size="large"
            startIcon={
              <Image
                height="25"
                width="25"
                src={extensionDetails.logo}
                alt={`${extensionDetails.browser} Logo`}
              />
            }>
            {extensionDetails.browser} Extension
          </Button>
        )}
        {api && (
          <Button
            sx={{ mr: 2 }}
            href="/api"
            variant="outlined"
            size="large"
            startIcon={<CodeIcon />}>
            API Access
          </Button>
        )}
        {mcp && (
          <Button
            sx={{ mr: 2 }}
            href="/mcp"
            variant="outlined"
            size="large"
            startIcon={<SmartToyIcon />}>
            MCP Server
          </Button>
        )}
        {compare && (
          <Button
            sx={{ mr: 2 }}
            href="/compare"
            variant="outlined"
            size="large"
            startIcon={<PieChartIcon />}>
            Compare Technologies
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
